import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNext = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 8,
	height: 12,
	viewBox: "0 0 8 12",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M71.2213207,17.0021331 L68,14.0039421 L74.4507644,8 L75.2253822,8.72096268 C75.6514749,9.11754135 76,9.44942563 76,9.45832996 C76,9.46723645 74.9050552,10.4938363 73.566861,11.7393744 L71.1337221,14.0039781 L73.566861,16.2685819 C74.905081,17.514108 76,18.540746 76,18.5496263 C76,18.5655641 74.4673455,20 74.4501971,20 C74.4456643,20 72.9920673,18.6509101 71.2202377,17.0018091 L71.2213207,17.0021331 Z",
		transform: "matrix(-1 0 0 1 76 -8)"
	})
});
export default SvgNext;
